import React from 'react'
import { Product } from '../../../../modules/productsListing/types'
import { FormikProps, useFormikContext } from 'formik'
import { PrivateOffer } from '../../../../modules/privateOffer/types'
import { BoxV4 } from '@labrav/react-components'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faListCheck } from '@fortawesome/pro-regular-svg-icons'
import { PaymentScheduleV2 } from '../../../../common/components/PaymentScheduleV2/PaymentScheduleV2'
import { awsMaxScheduledInstallments } from '../../../../common/utils/constants'

export type PrivateOfferInstallmentsProps = {
  product: Product
}
export const PrivateOfferInstallments: React.FC<
  PrivateOfferInstallmentsProps
> = () => {
  const formikProps = useFormikContext() as FormikProps<PrivateOffer>

  return (
    <div data-testid="Installments-section">
      <BoxV4
        heading={'Installments'}
        headingIcon={
          <FontAwesomeIcon
            icon={faListCheck}
            style={{ width: '18px', height: '14px' }}
          />
        }
      >
        <PaymentScheduleV2
          formik={
            formikProps as unknown as FormikProps<Record<string, unknown>>
          }
          addButtonName={'Add more installments'}
          buttonCounterName={'installments'}
          shouldShowTotal={true}
          installmentsLimit={awsMaxScheduledInstallments}
          validate={true}
        />{' '}
      </BoxV4>
    </div>
  )
}
